const rankingItems = [
  {
    rank: 1,
    title: '漫长的季节',
    tag: '国产剧',
    score: '9.4',
    hot: '本周热度第一',
    desc: '范伟秦昊主演，跨越二十年的东北悬疑故事',
    img: 'https://readdy.ai/api/search-image?query=A%20small%20thumbnail%20of%20autumn%20foliage%20in%20northern%20Chinese%20town%20with%20warm%20golden%20trees%2C%20nostalgic%20industrial%20background%2C%20soft%20afternoon%20light%2C%20simple%20composition&width=200&height=120&seq=tangxin-rank-01&orientation=landscape',
  },
  {
    rank: 2,
    title: '繁花',
    tag: '国产剧',
    score: '8.7',
    hot: '话题持续热议',
    desc: '王家卫导演首部电视剧，胡歌马伊琍主演',
    img: 'https://readdy.ai/api/search-image?query=A%20small%20thumbnail%20of%201990s%20Shanghai%20streets%20with%20neon%20lights%20and%20warm%20glow%2C%20nostalgic%20vintage%20atmosphere%2C%20simple%20dark%20background&width=200&height=120&seq=tangxin-rank-02&orientation=landscape',
  },
  {
    rank: 3,
    title: '周处除三害',
    tag: '电影',
    score: '8.1',
    hot: '新晋黑马',
    desc: '阮经天主演动作犯罪片，口碑持续走高',
    img: 'https://readdy.ai/api/search-image?query=A%20small%20thumbnail%20of%20dramatic%20urban%20night%20scene%20with%20warm%20street%20lights%2C%20moody%20shadow%20and%20light%20contrast%2C%20film%20noir%20style%2C%20simple%20dark%20background&width=200&height=120&seq=tangxin-rank-03&orientation=landscape',
  },
  {
    rank: 4,
    title: '庆余年第二季',
    tag: '国产剧',
    score: '8.3',
    hot: '续作期待拉满',
    desc: '张若昀领衔，古装权谋大剧强势回归',
    img: 'https://readdy.ai/api/search-image?query=A%20small%20thumbnail%20of%20ancient%20Chinese%20palace%20courtyard%20with%20warm%20lantern%20light%2C%20traditional%20architecture%2C%20elegant%20historical%20atmosphere%2C%20simple%20background&width=200&height=120&seq=tangxin-rank-04&orientation=landscape',
  },
  {
    rank: 5,
    title: '眼泪女王',
    tag: '韩剧',
    score: '8.5',
    hot: '浪漫话题刷屏',
    desc: '金秀贤金智媛主演，年度最热韩剧',
    img: 'https://readdy.ai/api/search-image?query=A%20small%20thumbnail%20of%20romantic%20spring%20cherry%20blossom%20scene%20with%20warm%20sunlight%2C%20soft%20pink%20petals%2C%20dreamy%20atmosphere%2C%20simple%20natural%20background&width=200&height=120&seq=tangxin-rank-05&orientation=landscape',
  },
  {
    rank: 6,
    title: '星际穿越',
    tag: '电影',
    score: '9.3',
    hot: '经典长红不衰',
    desc: '诺兰科幻神作，IMAX重映引发新一轮观影潮',
    img: 'https://readdy.ai/api/search-image?query=A%20small%20thumbnail%20of%20starry%20night%20sky%20with%20distant%20galaxy%2C%20deep%20space%20with%20warm%20starlight%2C%20cosmic%20wonder%2C%20simple%20dark%20background&width=200&height=120&seq=tangxin-rank-06&orientation=landscape',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-4">
            实时热度
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="text-foreground-500 text-sm mt-2">基于全网实时热度与用户评分综合排序</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="group flex items-start gap-4 bg-background-100 rounded-xl p-5 hover:bg-primary-50/40 transition-colors duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-heading font-bold text-lg shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-200 text-secondary-700'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 rounded bg-accent-100/70 text-accent-700 text-[10px] font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
                <div className="flex items-center gap-3">
                  <span className="flex items-center gap-1 text-sm font-heading font-bold text-primary-600">
                    <i className="ri-star-fill text-xs text-accent-500"></i>
                    {item.score}
                  </span>
                  <span className="text-xs text-foreground-400">{item.hot}</span>
                </div>
              </div>
              <div className="w-16 h-12 rounded-lg overflow-hidden bg-background-200 shrink-0 hidden sm:block">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}